export default __webpack_public_path__ + "static/media/craon29.f148f4df.jpg";